import { render, staticRenderFns } from "./FeedTankCorrections.vue?vue&type=template&id=384e9ca3&"
import script from "./FeedTankCorrections.vue?vue&type=script&lang=ts&"
export * from "./FeedTankCorrections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports